/* globals Forms, Editor */
import 'packery/dist/packery.pkgd'
import Draggabilly from 'draggabilly/draggabilly'

function initDraggableBoardingStep (step, container) {
  // step may be a raw DOM element or a jQuery object
  const el = (step instanceof Element) ? step : (step && step.get ? step.get(0) : null)
  if (!(el instanceof Element)) return
  container.packery('bindDraggabillyEvents', new Draggabilly(el, {
    handle: '.draggable-handle'
  }))
}

function reloadBoardingStepsPosition (container) {
  container.packery('getItemElements').forEach((el, index) => {
    $(el).find('.boarding_task_steps_position input').val(index + 1)
  })
}

function setupBoardingTaskForm () {
  const boardingStepAssociationLinks = $('#boarding_task_step_actions a')
  const boardingStepsContainer = $('#boarding_task_steps')

  // Forms.initInlineEdit(boardingStepsContainer);

  const packery = boardingStepsContainer.packery({
    itemSelector: '.field'
  })

  boardingStepsContainer.packery('getItemElements').forEach((step) => {
    initDraggableBoardingStep(step, boardingStepsContainer)
  })

  packery.on('layoutComplete', () => reloadBoardingStepsPosition(boardingStepsContainer))
  packery.on('dragItemPositioned', () => reloadBoardingStepsPosition(boardingStepsContainer))

  boardingStepAssociationLinks
    .data('association-insertion-method', 'append')
    .data('association-insertion-node', () => boardingStepsContainer)

  boardingStepsContainer
    .on('cocoon:after-insert', (e, step) => {
      ReactOnRails.reactOnRailsPageLoaded()
      Forms.initInputMasks(step)
      Forms.initCheckbox(step)
      Forms.initSelect2(step)
      Forms.initSelect2Tags(step)
      Editor.initEditor(step)

      boardingStepsContainer.packery('appended', step)
      boardingStepsContainer.packery('layout')

      boardingStepsContainer.data('packery').once('layoutComplete', () => {
        initDraggableBoardingStep(step, boardingStepsContainer)
      })
    })
    .on('cocoon:after-remove', (e, step) => {
      boardingStepsContainer.packery('layout')
    })
}

window['companies/boarding/tasks#new'] = setupBoardingTaskForm
window['companies/boarding/tasks#edit'] = setupBoardingTaskForm

window['companies/boarding/tasks#index'] = function () {
  $(document).on('change', '#q_tags_in', function () {
    const tags = $(this).val()
    $.ajax({
      url: window.location.pathname,
      data: { 'q[tags_in]': tags },
      dataType: 'script'
    })
  })
}
